import React, { useState } from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import {
  ICollection,
  IImage,
  ILabel,
} from '../../../../../utils/types/contentful';
import { Image } from '../../../Media/Image/index';
import { Button } from '../../../Elements';

export interface CollectionShopCard {
  label: ILabel;
  subLabel: ILabel;
  collection: ICollection;
  image: IImage;
}

export const CollectionShopCard: React.FC<CollectionShopCardProps> = ({
  category,
  label,
  subLabel,
  image,
}) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <div
      className='h-96 relative w-full overflow-hidden'
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}>
      {isHover && (
        <div className='absolute left-6 w-96 h-96 -z-1 bg-rose-600' />
      )}
      <div className='absolute h-full -z-1'>
        <Image
          {...image}
          objectFit='cover'
          width='100%'
          height='100%'
        />
      </div>
      <div className='px-8 py-4 flex'>
        <div className='w-3/4'>
          <Label
            {...label}
            color={{ classname: 'gray-800' }}
            truncate
            size='2xl'
            weight='bold'
          />
          <Label
            {...subLabel}
            truncate
            size='sm'
            decoration='underline'
            color={{ classname: 'gray-500' }}
          />
        </div>
        <div className='w-1/4 flex justify-end items-center'>
          <Button
            icon={{
              iconKey: 'HiOutlineChevronRight',
              size: 'xl',
              color: isHover ? 'white' : 'primary',
            }}
            type='contained'
            size='lg'
            color={{
              classname: isHover ? 'primary' : 'white',
            }}
          />
        </div>
      </div>
    </div>
  );
};
